import React from "react";

export function CaretDown() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M4 7L9 13L14.07 7H4Z" fill="currentColor" />
    </svg>
  );
}
